import { redo, undo } from 'prosemirror-history'
import { indentBy } from './commands/indentBy'

export const mac = typeof navigator != 'undefined' ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false

export const buildKeymap = () => {
  const map: Record<string, Function> = {
    'Mod-z': undo,
    'Shift-Mod-z': redo,
    Tab: indentBy(1),
    'Shift-Tab': indentBy(-1),
  }

  if (!mac) map['Mod-y'] = redo

  return map
}
